export const masoniteData = {
    projectHeading: 'The Masonite Website',
    projectMainImage: {
        image: '/images/portfolio/masonite/home-page.png',
        alt: 'Masonite Home Page'
    },
    additionalImages: [
        {
            fullImage: '/images/portfolio/masonite/home-page.png',
            image: '/images/portfolio/masonite/home-page-thumb.png',
            alt: 'Masonite Home Page'
        },
        {
            fullImage: '/images/portfolio/masonite/choose-your-profession-docs.png',
            image: '/images/portfolio/masonite/choose-your-profession-docs-thumb.png',
            alt: 'Choose Your Profession Documents'
        },
        {
            fullImage: '/images/portfolio/masonite/doors-101.png',
            image: '/images/portfolio/masonite/doors-101-thumb.png',
            alt: 'Doors 101'
        },
        {
            fullImage: '/images/portfolio/masonite/dream-quiz.png',
            image: '/images/portfolio/masonite/dream-quiz-thumb.png',
            alt: 'Dream Quiz'
        },
        {
            fullImage: '/images/portfolio/masonite/installation-and-care.png',
            image: '/images/portfolio/masonite/installation-and-care-thumb.png',
            alt: 'Installation and Care'
        },
        {
            fullImage: '/images/portfolio/masonite/localization-in-french.png',
            image: '/images/portfolio/masonite/localization-in-french-thumb.png',
            alt: 'Localization in French'
        },
        {
            fullImage: '/images/portfolio/masonite/masonite-worldwide.png',
            image: '/images/portfolio/masonite/masonite-worldwide-thumb.png',
            alt: 'Masonite Worldwide'
        },
    ],
    aboutHeading: 'About the Masonite Web Project',
    aboutPortfolioText: [
        ``
    ],
    websiteGoalsHeading: 'Website Goals',
    websiteGoalsText: [
        ``
    ],
    websiteGoalsListHeading: 'Website Goals List',
    websiteGoalsList: [
    ],
    myRoleHeading: 'My Role On The Masonite Web Project',
    position: 'Lead Full Stack Developer',
    company: 'Masonite',
    timeWithCompany: '6 years to current',
    myRoleText: [
        ``
    ],
    jobSummaryIntro: 'Following is a summary of my responsibilities while working on the Masonite Web project',
    jobSummaryList: [
        ``
    ],
    technologiesUsedIntro: `This section contains the technologies used for building the Masonite website.`,
    technologiesList: [
        ``
    ]
}